import { IngredientDetail } from './IngredientDetail';
import { useGetSupplementDetailQuery } from '@viome/viome-base/src/usecase/Nutrition/NutritionQuery';
import { useParams } from 'react-router-dom';
import { IngredientDetailSkeleton } from './IngredientDetailSkeleton';
import { ErrorLoadingPage } from '../ErrorHandling/ErrorLoadingPage';
import { getBackgroundImageUrl } from '@utils/nutrition/getImageUrl';

export const IngredientDetailPage = () => {
  const { id: ingredientId } = useParams();

  const { data, isLoading, isError } = useGetSupplementDetailQuery({
    ingredient_id: Number(ingredientId),
  });

  const {
    description,
    related_researches: relatedSearches,
    scores,
    title,
    badges = [],
    dosage_with_unit: dosageWithUnit,
    group_name: groupName,
    product_id: productId,
  } = data || {};

  const validScores = scores || [];

  if (isLoading) {
    return <IngredientDetailSkeleton data-testid="ingredientDetail-loading" />;
  }

  if (isError) {
    return <ErrorLoadingPage />;
  }

  return (
    <div
      data-testid="ingredientDetail-page"
      className="relative bg-cover bg-center"
      style={{
        backgroundImage: `url(${getBackgroundImageUrl('ingredient_detail_background.png')})`,
      }}
    >
      <IngredientDetail
        data-testid="ingredientDetail-content"
        title={title}
        description={description}
        dosageWithUnit={dosageWithUnit}
        groupName={groupName}
        subDescriptionLabel=""
        helperCards={badges}
        scoreCards={validScores}
        supportingResearch={relatedSearches}
        ingredientId={ingredientId}
        productId={productId}
      />
    </div>
  );
};
